import { FC } from "react";

const Train: FC = () => {
    return (
        <>
            <div className="fs-16 fw-700 text-black">Train</div>
            <svg
                width="31"
                height="30"
                viewBox="0 0 31 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                d="M11.125 20.625C12.1605 20.625 13 19.7855 13 18.75C13 17.7145 12.1605 16.875 11.125 16.875C10.0895 16.875 9.25 17.7145 9.25 18.75C9.25 19.7855 10.0895 20.625 11.125 20.625Z"
                fill="black"
                />
                <path
                d="M19.875 20.625C20.9105 20.625 21.75 19.7855 21.75 18.75C21.75 17.7145 20.9105 16.875 19.875 16.875C18.8395 16.875 18 17.7145 18 18.75C18 19.7855 18.8395 20.625 19.875 20.625Z"
                fill="black"
                />
                <path
                d="M15.5 3.125C10.5 3.125 5.5 3.75 5.5 8.125V20C5.5 22.4125 7.4625 24.375 9.875 24.375L8 26.25V26.875H10.5L13 24.375H18L20.5 26.875H23V26.25L21.125 24.375C23.5375 24.375 25.5 22.4125 25.5 20V8.125C25.5 3.75 20.5 3.125 15.5 3.125ZM15.5 5.625C19.8875 5.625 21.7 6.225 22.4625 6.875H8.5375C9.3 6.225 11.1125 5.625 15.5 5.625ZM8 9.375H14.25V13.125H8V9.375ZM23 20C23 21.0375 22.1625 21.875 21.125 21.875H9.875C8.8375 21.875 8 21.0375 8 20V15.625H23V20ZM23 13.125H16.75V9.375H23V13.125Z"
                fill="black"
                />
            </svg>
        </>
    )
}

export default Train;